
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M20 4C20 5.10457 19.1046 6 18 6C17.2597 6 16.6134 5.5978 16.2676 5H10C8.34315 5 7 6.34315 7 8C7 9.65685 8.34315 11 10 11H10.2676C10.6134 10.4022 11.2597 10 12 10C12.7403 10 13.3866 10.4022 13.7324 11H14C15.1662 11 16.2392 11.3993 17.0897 12.0686C16.1737 12.208 15.3257 12.5546 14.5951 13.059C14.4028 13.0203 14.2037 13 14 13H13.7324C13.3866 13.5978 12.7403 14 12 14C11.2597 14 10.6134 13.5978 10.2676 13H10C7.23858 13 5 10.7614 5 8C5 5.23858 7.23858 3 10 3H16.2676C16.6134 2.4022 17.2597 2 18 2C19.1046 2 20 2.89543 20 4ZM12.083 19H7.73244C7.38663 18.4022 6.74028 18 6 18C4.89543 18 4 18.8954 4 20C4 21.1046 4.89543 22 6 22C6.74028 22 7.38663 21.5978 7.73244 21H12.8027C12.4513 20.3926 12.2034 19.7179 12.083 19Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M19.8536 15.1465L22.2071 17.5H14V16.5H19.7929L19.1464 15.8536L19.8536 15.1465Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M16.4142 19.5H22.2071V18.5H14L16.3535 20.8536L17.0606 20.1464L16.4142 19.5Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowcallFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
